import { RouteObject } from "react-router-dom";

export default [
  {
    index: true,
    lazy: () => import("modules/settings/pages/SettingsHome"),
  },
  {
    path: "ai",
    lazy: () => import("modules/settings/pages/SettingsAi"),
  },
] as RouteObject[];
